import { createSlice, PayloadAction } from "@reduxjs/toolkit";

type FetchStatus =
  | "IDLE"
  | "IN_PROGRESS"
  | "SUCCESS"
  | "TECHNICAL_ERROR"
  | "NO_CLIENTS_CONNECTED"
  | "INSUFFICIENT_DATA";

export interface AgencyDashboardState {
  status: FetchStatus;
  customDataPeriodStatus: FetchStatus;
  customDataPeriodJobId: string | number | null;
  refresh: boolean;
  jobId: string | number | null;
  data: any | null;
  isBannerVisible?: boolean;
  isTemp: boolean;
  error: string | null;
  lastUpdated: number | null;
}

const initialState: AgencyDashboardState = {
  status: "IDLE",
  customDataPeriodStatus: "IDLE",
  customDataPeriodJobId: null,
  refresh: false,
  jobId: null,
  data: null,
  error: null,
  lastUpdated: null,
  isBannerVisible: false,
  isTemp: false,
};

const agencydashboardslice = createSlice({
  name: "agencydashboardslice",
  initialState,
  reducers: {
    setStatus(state, action: PayloadAction<FetchStatus>) {
      state.status = action.payload;
      if (action.payload !== "TECHNICAL_ERROR") state.error = null;
    },
    setCustomDataPeiodStatus(state, action: PayloadAction<FetchStatus>) {
      state.customDataPeriodStatus = action.payload;
      if (action.payload !== "TECHNICAL_ERROR") state.error = null;
    },
    setRefresh(state, action: PayloadAction<boolean>) {
      state.refresh = action.payload;
    },
    setJobId(state, action: PayloadAction<string | number | null>) {
      if (state.jobId == action.payload) {
        state.status = "SUCCESS";
        state.refresh = true;
        return;
      }
      state.jobId = action.payload;
    },
    setCustomDataPeiodJobId(
      state,
      action: PayloadAction<string | number | null>
    ) {
      if (state.customDataPeriodJobId == action.payload) {
        state.customDataPeriodStatus = "SUCCESS";
        state.refresh = true;
        return;
      }
      state.customDataPeriodJobId = action.payload;
    },
    setData(state, action: PayloadAction<any>) {
      state.data = action.payload;
      state.lastUpdated = Date.now();
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
      state.status = "TECHNICAL_ERROR";
    },
    setBannerVisible(state, action: PayloadAction<boolean>) {
      state.isBannerVisible = action.payload;
    },
    setIsTemp(state, action: PayloadAction<boolean>) {
      state.isTemp = action.payload;
    },
    resetAgDashboard(state, action: PayloadAction<boolean>) {
      state = {
        ...initialState,
      };
      return state;
    },
  },
});

export const {
  setStatus,
  setJobId,
  setData,
  setError,
  setBannerVisible,
  resetAgDashboard,
  setRefresh,
  setIsTemp,
  setCustomDataPeiodJobId,
  setCustomDataPeiodStatus,
} = agencydashboardslice.actions;

export const agencydashboardReducer = agencydashboardslice.reducer;
